var _g, _path, _path2, _g2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 90,
  height: 91,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-1_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#9F238C",
  d: "M45 90.5c24.853 0 45-20.147 45-45S69.853.5 45 .5 0 20.647 0 45.5s20.147 45 45 45"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F1DCC2",
  d: "m32.9 70.642-2.716-14.441c-3.203 3.343-6.407.278-6.964-.28-.557-.556-3.343-3.9-1.532-7.242s5.85-1.532 5.85-1.532L24.474 34.61C23.068 15.538 49.824 21.1 49.824 21.1s10.4 4.99 14.346 10.029c4.481 5.72-4.479 7.436-4.479 7.436 7.406 11.675-1.37 19.723-5.596 26.45-2.53 4.027-2.114 6.14-2.114 6.14s1.025 1.04.886 1.736c-.14.697-11.074 2.159-12.885 1.602s-6.326.173-7.082-3.851"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#171717",
  d: "M42.696 35.165a1.486 1.486 0 1 0 0-2.972 1.486 1.486 0 0 0 0 2.972M50.496 30.847a1.486 1.486 0 1 0 0-2.971 1.486 1.486 0 0 0 0 2.971"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-1_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F5C400",
  d: "m51.982 71.155-19.083-.513c.585 3.182.853 10.373.951 18.566a45 45 0 0 0 11.119 1.387A44.8 44.8 0 0 0 63 86.825c-1.75-4.604-4.932-10.398-11.02-15.67"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#171717",
  d: "M49.823 21.1s6.348-2.977 8.357 1.102c2.01 4.079-3.017-13.48-11.166-8.729 0 0-.255-1.756.952-2.065 1.207-.31-4.179-.104-4.364 3.305 0 0-.836-2.065 0-2.685s-5.293 0-6.593 3.615c0 0-11.421-3.615-18.85 3.512 0 0 3.343.413 2.136 5.681 0 0-1.95 3.358 0 6.224s2.588 18.844 8.728 18.844c7.615 0-2.228-7.252-3.713-16.522-.001 0 18.051-13.072 24.513-12.281"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-1_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h90v90H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-1_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h90v90H0z"
})))));
export { SvgAvatar1 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-1.4e38914183ca3f0de37e.svg";